import { useState } from "react";

function MentorsProfile({ ytUrl }) {
  const [visible, setVisible] = useState(false);

  const leftTags = ["Python", "Machine Learning", "Deep Learning", "LLMs", "RAG", "Agentic AI"];
  const expertise = ["GenAI", "LLMs", "RAG", "Agentic AI", "ML Systems", "Python"];

  return (
    <div className="aiml-demo">
      <style>{aimlDemoStyles}</style>

      <div className="aiml-demo__grid">
        {/* ---------------- LEFT : Masterclass / video preview ---------------- */}
        <div className="aiml-demo__media">
          <span className="aiml-demo__glow aiml-demo__glow--a" aria-hidden="true" />
          <span className="aiml-demo__glow aiml-demo__glow--b" aria-hidden="true" />

          {!visible ? (
            <div className="aiml-video" onClick={() => setVisible(true)}>
              <div className="aiml-video__grid-overlay" aria-hidden="true" />
              <div className="aiml-video__top">
                <span className="aiml-badge-live">
                  <span className="aiml-dot" /> LIVE
                </span>
                <span className="aiml-pill-free">Free Session</span>
              </div>

              <div className="aiml-video__center">
                <button
                  type="button"
                  className="aiml-play"
                  aria-label="Watch the AI demo class"
                  onClick={(e) => {
                    e.stopPropagation();
                    setVisible(true);
                  }}
                >
                  <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
                    <path d="M8 5.14v13.72a1 1 0 0 0 1.52.86l11-6.86a1 1 0 0 0 0-1.72l-11-6.86A1 1 0 0 0 8 5.14Z" />
                  </svg>
                </button>
              </div>

              <div className="aiml-video__bottom">
                <p className="aiml-video__eyebrow">Free Live AI Demo Session</p>
                <h3 className="aiml-video__title">Watch the AI / ML &amp; GenAI Masterclass</h3>
                <p className="aiml-video__sub">AI / ML / GenAI for Working Professionals</p>
                <div className="aiml-tagrow">
                  {leftTags.map((t) => (
                    <span className="aiml-chip aiml-chip--ghost" key={t}>{t}</span>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <div className="aiml-video aiml-video--playing">
              <button
                type="button"
                className="aiml-video__close"
                aria-label="Close video"
                onClick={() => setVisible(false)}
              >
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                  <path d="M6 6l12 12M18 6L6 18" />
                </svg>
              </button>
              <iframe
                src={ytUrl}
                title="AI &amp; ML Demo Class"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          )}
        </div>

        {/* ---------------- RIGHT : Featured mentor panel ---------------- */}
        <div className="aiml-mentor">
          <span className="aiml-mentor__role">Head Instructor &amp; AI Mentor</span>

          <div className="aiml-mentor__head">
            <div className="aiml-mentor__avatar">
              <img
                src="https://logicmojo.com/assets/dist/new_index_design/images/rishab.jpg"
                alt="Rishabh Gupta"
                loading="lazy"
              />
              <span className="aiml-mentor__ring" aria-hidden="true" />
            </div>
            <div className="aiml-mentor__id">
              <h4>
                Rishabh Gupta
                <a
                  href="https://www.linkedin.com/in/rishabhgupta96/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Rishabh Gupta on LinkedIn"
                  className="aiml-li"
                >
                  <svg viewBox="0 0 16 16" width="16" height="16" fill="currentColor">
                    <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                  </svg>
                </a>
                <a
                  href="https://github.com/RishGupta"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Rishabh Gupta on GitHub"
                  className="aiml-gh"
                >
                  <svg viewBox="0 0 16 16" width="16" height="16" fill="currentColor">
                    <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
                  </svg>
                </a>
              </h4>
              <p className="aiml-mentor__title">Lead AI Engineer @ Uber · Ex-MakeMyTrip</p>
              <div className="aiml-mentor__meta">
                <span className="aiml-meta-pill">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M22 10v6M2 10l10-5 10 5-10 5z"/><path strokeLinecap="round" strokeLinejoin="round" d="M6 12v5c3 3 9 3 12 0v-5"/></svg>
                  M.S. — Stony Brook University
                </span>
                <span className="aiml-meta-pill">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="14" rx="2"/><path strokeLinecap="round" d="M8 20h8"/></svg>
                  Ex-Microsoft &amp; MakeMyTrip
                </span>
              </div>
            </div>
          </div>

          <div className="aiml-chiprow">
            {expertise.map((e) => (
              <span className="aiml-chip aiml-chip--solid" key={e}>{e}</span>
            ))}
          </div>

          <p className="aiml-mentor__desc">
            Rishabh builds production AI systems at scale — from LLM-powered products and
            RAG pipelines to agentic workflows. With 5+ years mentoring engineers, he
            translates real-world GenAI engineering into a structured, hands-on path for
            working professionals breaking into AI.
          </p>

          <div className="aiml-cred">
            <div className="aiml-cred__item">
              <strong>1000+</strong>
              <span>Learners mentored</span>
            </div>
            <div className="aiml-cred__item">
              <strong>Top</strong>
              <span>Product companies</span>
            </div>
            <div className="aiml-cred__item">
              <strong>Hands-on</strong>
              <span>Industry AI projects</span>
            </div>
          </div>

          <div className="aiml-cta">
            <a href="#Demo" className="aiml-btn aiml-btn--primary" onClick={() => setVisible(true)}>
              Join Free Demo
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M13 6l6 6-6 6"/></svg>
            </a>
            <a href="#syllabus" className="aiml-btn aiml-btn--ghost">View Curriculum</a>
          </div>
        </div>
      </div>
    </div>
  );
}

const aimlDemoStyles = `
.aiml-demo{
  --ai-blue:#2563eb; --ai-indigo:#4f46e5; --ai-violet:#7c3aed; --ai-cyan:#06b6d4;
  --ai-ink:#0f172a; --ai-muted:#64748b; --ai-line:#e7eaf3;
  max-width:1180px;margin:0 auto;padding:8px 16px 0;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;
  text-align:left;
}
.aiml-demo *{box-sizing:border-box;}
.aiml-demo__grid{
  display:grid;grid-template-columns:1.05fr .95fr;gap:28px;align-items:stretch;
}

/* ---- left media ---- */
.aiml-demo__media{position:relative;border-radius:24px;}
.aiml-demo__glow{position:absolute;border-radius:50%;filter:blur(60px);z-index:0;opacity:.55;pointer-events:none;}
.aiml-demo__glow--a{width:220px;height:220px;background:#7c3aed;top:-40px;left:-30px;}
.aiml-demo__glow--b{width:240px;height:240px;background:#06b6d4;bottom:-50px;right:-30px;opacity:.4;}

.aiml-video{
  position:relative;z-index:1;height:100%;min-height:360px;border-radius:24px;overflow:hidden;
  cursor:pointer;display:flex;flex-direction:column;justify-content:space-between;
  padding:20px;color:#fff;
  background:
    radial-gradient(120% 120% at 0% 0%, rgba(124,58,237,.95) 0%, rgba(37,99,235,.92) 45%, rgba(15,23,42,.98) 100%);
  box-shadow:0 30px 60px -25px rgba(37,55,120,.55);
  border:1px solid rgba(255,255,255,.12);
  transition:transform .35s ease, box-shadow .35s ease;
}
.aiml-video:hover{transform:translateY(-4px);box-shadow:0 40px 80px -30px rgba(37,55,120,.7);}
.aiml-video__grid-overlay{
  position:absolute;inset:0;z-index:0;opacity:.4;
  background-image:linear-gradient(rgba(255,255,255,.08) 1px,transparent 1px),
    linear-gradient(90deg,rgba(255,255,255,.08) 1px,transparent 1px);
  background-size:34px 34px;
  -webkit-mask-image:radial-gradient(120% 80% at 50% 30%,#000 30%,transparent 75%);
  mask-image:radial-gradient(120% 80% at 50% 30%,#000 30%,transparent 75%);
}
.aiml-video__top,.aiml-video__center,.aiml-video__bottom{position:relative;z-index:2;}
.aiml-video__top{display:flex;justify-content:space-between;align-items:center;}
.aiml-badge-live{
  display:inline-flex;align-items:center;gap:7px;font-size:12px;font-weight:700;letter-spacing:.06em;
  background:rgba(239,68,68,.18);color:#fecaca;padding:6px 12px;border-radius:999px;
  border:1px solid rgba(239,68,68,.4);
}
.aiml-dot{width:8px;height:8px;border-radius:50%;background:#ef4444;box-shadow:0 0 0 0 rgba(239,68,68,.7);animation:aimlPulse 1.6s infinite;}
@keyframes aimlPulse{0%{box-shadow:0 0 0 0 rgba(239,68,68,.6);}70%{box-shadow:0 0 0 9px rgba(239,68,68,0);}100%{box-shadow:0 0 0 0 rgba(239,68,68,0);}}
.aiml-pill-free{font-size:12px;font-weight:600;background:rgba(255,255,255,.14);padding:6px 12px;border-radius:999px;backdrop-filter:blur(6px);border:1px solid rgba(255,255,255,.18);}
.aiml-video__center{flex:1;display:flex;align-items:center;justify-content:center;}
.aiml-play{
  width:74px;height:74px;border-radius:50%;border:none;cursor:pointer;color:#4f46e5;
  background:rgba(255,255,255,.95);display:flex;align-items:center;justify-content:center;
  padding-left:5px;box-shadow:0 12px 30px rgba(0,0,0,.35);transition:transform .25s ease;
  animation:aimlRing 2.4s infinite;
}
.aiml-play:hover{transform:scale(1.08);}
@keyframes aimlRing{0%{box-shadow:0 0 0 0 rgba(255,255,255,.5),0 12px 30px rgba(0,0,0,.35);}70%{box-shadow:0 0 0 18px rgba(255,255,255,0),0 12px 30px rgba(0,0,0,.35);}100%{box-shadow:0 0 0 0 rgba(255,255,255,0),0 12px 30px rgba(0,0,0,.35);}}
.aiml-video__eyebrow{font-size:12px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#a5b4fc;margin:0 0 6px;}
.aiml-video__title{font-size:22px;line-height:1.25;font-weight:800;margin:0 0 6px;color:#fff;}
.aiml-video__sub{font-size:14px;color:rgba(255,255,255,.8);margin:0 0 14px;}
.aiml-tagrow{display:flex;flex-wrap:wrap;gap:8px;}
.aiml-chip{font-size:12px;font-weight:600;padding:6px 11px;border-radius:999px;white-space:nowrap;}
.aiml-chip--ghost{background:rgba(255,255,255,.12);color:#e2e8f0;border:1px solid rgba(255,255,255,.2);backdrop-filter:blur(4px);}
.aiml-video--playing{padding:0;background:#000;cursor:default;}
.aiml-video--playing iframe{width:100%;height:100%;min-height:360px;border:0;display:block;}
.aiml-video__close{
  position:absolute;top:10px;right:10px;z-index:5;
  width:40px;height:40px;border-radius:50%;border:1px solid rgba(255,255,255,.25);
  background:rgba(15,23,42,.75);color:#fff;cursor:pointer;
  display:flex;align-items:center;justify-content:center;
  backdrop-filter:blur(4px);box-shadow:0 6px 16px rgba(0,0,0,.4);
  transition:background .2s ease,transform .2s ease;
}
.aiml-video__close:hover{background:rgba(15,23,42,.95);transform:scale(1.08);}

/* ---- right mentor ---- */
.aiml-mentor{
  position:relative;z-index:1;border-radius:24px;padding:26px;
  background:linear-gradient(180deg,#ffffff 0%,#fafbff 100%);
  border:1px solid var(--ai-line);
  box-shadow:0 24px 50px -28px rgba(37,55,120,.35);
  display:flex;flex-direction:column;
}
.aiml-mentor__role{
  align-self:flex-start;font-size:12px;font-weight:700;letter-spacing:.04em;
  color:#4f46e5;background:linear-gradient(90deg,#ede9fe,#e0e7ff);
  padding:7px 14px;border-radius:999px;border:1px solid #ddd6fe;margin-bottom:18px;
}
.aiml-mentor__head{display:flex;gap:16px;align-items:center;}
.aiml-mentor__avatar{position:relative;flex-shrink:0;width:74px;height:74px;}
.aiml-mentor__avatar img{width:74px;height:74px;border-radius:50%;object-fit:cover;position:relative;z-index:1;background:#facc15;}
.aiml-mentor__ring{position:absolute;inset:-4px;border-radius:50%;z-index:0;background:conic-gradient(from 180deg,#7c3aed,#2563eb,#06b6d4,#7c3aed);filter:blur(.5px);animation:aimlSpin 6s linear infinite;}
@keyframes aimlSpin{to{transform:rotate(360deg);}}
.aiml-mentor__id h4{display:flex;align-items:center;gap:8px;font-size:20px;font-weight:800;color:var(--ai-ink);margin:0 0 3px;}
.aiml-li{display:inline-flex;width:24px;height:24px;align-items:center;justify-content:center;border-radius:6px;background:#0a66c2;color:#fff;transition:transform .2s ease;}
.aiml-li:hover{transform:translateY(-2px);}
.aiml-gh{display:inline-flex;width:24px;height:24px;align-items:center;justify-content:center;border-radius:6px;background:#24292f;color:#fff;transition:transform .2s ease;}
.aiml-gh:hover{transform:translateY(-2px);color:#fff;}
.aiml-mentor__title{font-size:13.5px;font-weight:600;color:var(--ai-indigo);margin:0 0 8px;}
.aiml-mentor__meta{display:flex;flex-wrap:wrap;gap:6px;}
.aiml-meta-pill{display:inline-flex;align-items:center;gap:6px;font-size:11.5px;font-weight:500;color:var(--ai-muted);background:#f1f5fb;border:1px solid var(--ai-line);padding:4px 9px;border-radius:8px;}
.aiml-chiprow{display:flex;flex-wrap:wrap;gap:8px;margin:18px 0 0;}
.aiml-chip--solid{background:linear-gradient(90deg,#eef2ff,#f5f3ff);color:#4338ca;border:1px solid #e0e7ff;}
.aiml-mentor__desc{font-size:14px;line-height:1.65;color:#475569;margin:16px 0 0;}
.aiml-cred{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin:18px 0;}
.aiml-cred__item{background:#f8faff;border:1px solid var(--ai-line);border-radius:14px;padding:12px 10px;text-align:center;}
.aiml-cred__item strong{display:block;font-size:18px;font-weight:800;background:linear-gradient(90deg,#7c3aed,#2563eb);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;}
.aiml-cred__item span{font-size:11.5px;color:var(--ai-muted);line-height:1.3;display:block;margin-top:2px;}
.aiml-cta{display:flex;gap:12px;margin-top:auto;flex-wrap:wrap;}
.aiml-btn{display:inline-flex;align-items:center;gap:8px;font-size:14px;font-weight:700;padding:13px 22px;border-radius:12px;cursor:pointer;text-decoration:none;transition:transform .2s ease,box-shadow .2s ease,background .2s ease;border:1px solid transparent;}
.aiml-btn--primary{color:#fff;background:linear-gradient(90deg,#7c3aed,#2563eb);box-shadow:0 12px 24px -8px rgba(79,70,229,.6);}
.aiml-btn--primary:hover{transform:translateY(-2px);box-shadow:0 16px 30px -8px rgba(79,70,229,.7);color:#fff;}
.aiml-btn--ghost{color:#4338ca;background:#fff;border-color:#ddd6fe;}
.aiml-btn--ghost:hover{background:#f5f3ff;transform:translateY(-2px);color:#4338ca;}

@media(max-width:900px){
  .aiml-demo__grid{grid-template-columns:1fr;gap:20px;}
  .aiml-video{min-height:300px;}
}
@media(max-width:480px){
  .aiml-mentor{padding:20px;}
  .aiml-video__title{font-size:19px;}
  .aiml-cred{gap:8px;}
  .aiml-btn{flex:1;justify-content:center;}
}
`;

export default MentorsProfile;
